module.exports = __webpack_public_path__ + "static/media/thonburi.57cc8436.svg";